<template>
    <div id="index" :style="bgImage" ref="appRef">


        <div style="height: calc(100% - 60px);
        position: absolute;
   top: 80px;
   left: 0px;
   z-index: 1;
   width: 100%;">
            <div class="bg">
                <Shouye v-if="activeComponents=='Shouye'" :activeComponents="activeComponents" @changeActiveComponents="changeActiveComponents"></Shouye>
                <resourceStatus v-if="activeComponents=='resourceStatus'"></resourceStatus>
                <ecologicalCondition v-if="activeComponents=='ecologicalCondition'"></ecologicalCondition>
                <pestStatus v-if="activeComponents=='pestStatus'"></pestStatus>
            </div>

        </div>


        <div class="header">
            <div class="Header-container">
                <Header 
                :headerTitle="headerTitle"
                :activeComponents="activeComponents"
                 @changeActiveComponents="changeActiveComponents" />
            </div>
        </div>
        <!-- <div>
        <Shouye></Shouye>
      </div> -->


    </div>
</template>
  
<script>
import drawMixin from "./fixer"
import { Map, View, Feature } from "ol";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer";
import { XYZ, Vector as VectorSource, TileWMS } from "ol/source";
import "ol/ol.css";
import CFG from "@/config/config.json";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import FileSaver from "file-saver";
import XLSX from "xlsx";
import Header from "./header";
import Shouye from "./components/shouye";
import resourceStatus from "./components/resource-status";
import ecologicalCondition from "./components/ecological-condition";
import pestStatus from "./components/pest-status";

export default {
    components: { Treeselect, Header, Shouye, resourceStatus, ecologicalCondition, pestStatus },
    // mixins: [drawMixin],
    data() {
        return {
            featureOverlayDeviceMap: null,
            lineFeatureOverlay: null,
            map: null,
            user: this.$store.state.res_data,
            taskNameList: [],
            pointList: [],
            queryParams: {
                taskId: "",
                type: "",
                orgId: null,
                status: "",
                year: "",
                typeOfPest: "",
            },
            systemRole_code: this.$store.state.res_data.sysRoles[0].code,
            drawer: false,
            direction: 'rtl',
            drawerInfo: {},
            listQuery: {
                size: 9999999,
                current: 1,
                total: 10,
            },
            dispalyObj: {
                display: "inline",
            },

            token: "Bearer" + " " + this.$store.state.token,


            district: null,
            polygon: null,
            markers: [],
            type: "map",
            // type: "image",
            width: 0,
            bgImage: {},
            activeComponents:'Shouye'
        };
    },
    created() {
        console.log(drawMixin)
        console.log(this.mixins)


        // bindwindowSizeChanged(()=>{
        //     this.$forceUpdate()
        // })

    },
    watch: {

        '$route.meta.title': {
            handler(val) {
                if (val == "数字地图") {
                    console.log("aaaaaaaaa-----------")
                    this.drawer = false
                    // this.map = null
                    setTimeout(() => {
                        this.initMap()
                        this.getXzqh();
                        this.findTaskNameByMap();
                        this.findOrganizationById()
                    }, 500);


                }

            },
            deep: true
        },


    },
    methods: {
        changeActiveComponents(value){
            this.activeComponents=value
        },
        initMap() {
            console.log("initmap========")
            this.map = new Map({
                target: "index",
                layers: [
                    new TileLayer({
                        source: new XYZ({
                            crossOrigin: "anonymous",
                            url: "https://webst04.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}"
                        }),
                        name: "baseLayer1"
                    })
                ],
                view: new View({
                    projection: "EPSG:4326", //使用这个坐标系
                    center: [96.90903585532304, 33.39698851449892],
                    zoom: 10.5
                })
            });

        },




    },
    mounted() {

        console.log(this.type,"===========")
        console.log(this.$route.query);
    console.log(this.$route.params.systemSid);

        if (this.type == 'image') {
            this.bgImage = {
                'background-image': 'url("img/pageBg.png")',
                'background-size': 'cover',
                'background-position': 'center center'
            }
        } else {
            this.bgImage = {}
            this.initMap()
        }

        // if (this.type == "map") {
        //     this.initMap()
        // }

        // this.initMap()

    },
};
</script>
  
<style scoped lang='scss'>
/deep/.ol-overlaycontainer-stopevent {
    z-index: 2 !important;
}

.image_title {

    text-align: center;
    color: #00ffff;
    font-size: 2vw;
    height: 40px;
    line-height: 40px;
    font-weight: 500;
}

.title_icon {
    transform: rotate(90deg);
    font-weight: 700;
    color: #00ffff;
}

.resource-title {
    color: #fff;
    font-size: 2vw;
    height: 40px;
    line-height: 40px;
    margin-top: -10px;
    font-weight: 500;
}

.image_base {
    width: 100%;
    height: 100%;
    padding: 16px 16px 0 16px;
    background-image: url("../../assets/large-screen-img/ditu.png");
    background-size: cover;
    background-position: center center;
}

// .image_base {
//     border: 1px solid blue;
//     position: absolute;
//     margin-top: 0px;
//     height: 100%;
//     width: 100%;
//     margin: 0px auto;
//     background: url("../../assets/large-screen-img/ditu.png") no-repeat;
//     background-size: cover;
// }

// .image_base{
//     width: 100%;height: 100%;
//             background-image: url("../../assets/large-screen-img/ditu.png");
//   background-position: center;
//   background-repeat: no-repeat;

// }

.Header-container {
    width: 100%;
    height: 100%;
}

.header {
    z-index: 1;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    height: 80px;
    line-height: 80px;

    background-position: center;
    background-repeat: no-repeat;
    /*background-size: "contain"*/
}

@import './index.scss';
</style>
  